import React from 'react';
import HomeHero from '../components/home/HomeHero';
import CategoryGrid from '../components/home/CategoryGrid';
import FeaturedCollection from '../components/home/FeaturedCollection';
import ArtistStory from '../components/home/ArtistStory';
import FeaturedMusic from '../components/home/FeaturedMusic';
import NewsletterSection from '../components/home/NewsletterSection';
import NewsletterPopup from '../components/home/NewsletterPopup';
import SEO from '../components/seo/SEO';

const HomePage: React.FC = () => (
  <>
    <SEO path="/" />
    <NewsletterPopup />
    <HomeHero />
    <CategoryGrid />
    <FeaturedCollection />
    <ArtistStory />
    <FeaturedMusic />
    <NewsletterSection />
  </>
);

export default HomePage;
